<template>
  <slider-news />

  <the-nav />

  <div class="main-wrap">
    <div class="news-wrap">
      <div class="tt-tabs tournaments-tabs">
        <div class="index-tabs">
          <span @click="this.tabActive = 0" :class="this.tabActive === 0 ? 'active-ttab' : ''">Все новости</span>
          <!--          <span @click="this.tabActive = 1" :class="this.tabActive === 1 ? 'active-ttab' : ''">Промоакции</span>-->
          <!--          <span @click="this.tabActive = 2" :class="this.tabActive === 2 ? 'active-ttab' : ''">Новые игры</span>-->
        </div>
        <div class="index-panel">
          <div v-if="this.tabActive === 0" class="tt-panel">
            <div class="news-fl">
              <template v-for="n in news" :key="n.slug">
                <NewsItem :title="n.title" :image="n.icon" :full-text="n.full_text" :slug="n.slug" />
              </template>
            </div>
            <!--            <center><a href="#" class="loadnews-btn">Загрузить еще</a></center>-->
          </div>
          <!--          <div v-if="this.tabActive === 1" class="tt-panel">-->
          <!--            <div class="news-fl">-->
          <!--              <div class="news-item">-->
          <!--                <div class="news-item-image" style="background-image: url(/images/news-item1.png)"></div>-->
          <!--                <div class="news-item-content">-->
          <!--                  <div class="news-item-title">Новый дизайн сайта Миллионъ</div>-->
          <!--                  <div class="news-item-text">-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                  </div>-->
          <!--                  <div class="news-item-resize-btn"><span>Показать всю новость</span><span>Скрыть</span></div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="news-item">-->
          <!--                <div class="news-item-image" style="background-image: url(/images/news-item2.png)"></div>-->
          <!--                <div class="news-item-content">-->
          <!--                  <div class="news-item-title">Новый дизайн сайта Миллионъ</div>-->
          <!--                  <div class="news-item-text">-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                  </div>-->
          <!--                  <div class="news-item-resize-btn"><span>Показать всю новость</span><span>Скрыть</span></div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="news-item">-->
          <!--                <div class="news-item-image" style="background-image: url(/images/news-item3.png)"></div>-->
          <!--                <div class="news-item-content">-->
          <!--                  <div class="news-item-title">Новый дизайн сайта Миллионъ</div>-->
          <!--                  <div class="news-item-text">-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                  </div>-->
          <!--                  <div class="news-item-resize-btn"><span>Показать всю новость</span><span>Скрыть</span></div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div v-if="this.tabActive === 2" class="tt-panel">-->
          <!--            <div class="news-fl">-->
          <!--              <div class="news-item">-->
          <!--                <div class="news-item-image" style="background-image: url(/images/news-item4.png)"></div>-->
          <!--                <div class="news-item-content">-->
          <!--                  <div class="news-item-title">Новый дизайн сайта Миллионъ</div>-->
          <!--                  <div class="news-item-text">-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                  </div>-->
          <!--                  <div class="news-item-resize-btn"><span>Показать всю новость</span><span>Скрыть</span></div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="news-item">-->
          <!--                <div class="news-item-image" style="background-image: url(/images/news-item5.png)"></div>-->
          <!--                <div class="news-item-content">-->
          <!--                  <div class="news-item-title">Новый дизайн сайта Миллионъ</div>-->
          <!--                  <div class="news-item-text">-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                    <p>-->
          <!--                      Не пропустите популярные во всем мире игровые автоматы Green Tube теперь доступны в нашем клубе.-->
          <!--                      Более 30 новинок уже доступны на сайте.-->
          <!--                    </p>-->
          <!--                  </div>-->
          <!--                  <div class="news-item-resize-btn"><span>Показать всю новость</span><span>Скрыть</span></div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import PlayLine from '@/components/PlayLine'
import SliderNews from '@/components/sliders/SliderNews'
import TheNav from '@/components/TheNav'
import BonusesLine from '@/components/BonusesLine.vue'
import NewsItem from '@/components/news/NewsItem.vue'
import { FETCH_NEWS } from '@/store/actions.type'
import { mapGetters } from 'vuex'

export default {
  name: 'News',
  components: { NewsItem, BonusesLine, TheNav, PlayLine, SliderNews },
  data() {
    return {
      tabActive: 0,
    }
  },
  computed: {
    ...mapGetters(['news']),
  },
  created() {
    this.$store.dispatch(FETCH_NEWS)
  },
}
</script>

<style scoped></style>
